import { createClient } from "@supabase/supabase-js";

// Public (read-only) Supabase client for the website. The anon key is meant to
// be visible in the browser: Row Level Security only lets it READ the catalog
// (packages, hotels, visas, cabs, custom-trip settings) and submit custom-trip
// enquiries. All admin writes go through the backend — see ./adminDb.js.
//
// Set REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY at build time to
// point a deployment at a different project; the defaults are this site's.
const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL || "https://iozfllxuojslynduxmcc.supabase.co";
const supabaseKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlvemZsbHh1b2pzbHluZHV4bWNjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMzOTQwMzUsImV4cCI6MjA4ODk3MDAzNX0.51z_cxifdgZK57cRQ5MgePLkuZgKWAyszoDexZB4XSo";

export const supabase = createClient(supabaseUrl, supabaseKey);
